/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/core/Model',
	'../../lib/@waca/core-client/js/core-client/utils/UniqueId',
	'./ConditionalStyleCollection',
	'./ConditionalStyle'
], function(Model, UniqueId, ConditionalStyleCollection, ConditionalStyle) {


	/**
	 * The conditional attributes of the widget
	 */
	// Declare the class
	return class ConditionalPalette extends Model {
		constructor(...args) {
			super(...args);
		}

		init (...args) {
			this.nestedCollections = {
				colors: ConditionalStyleCollection
			};
			this.whitelistAttrs = ['colors'];
			super.init(...args);
		}

		getColors () {
			return this.colors;
		}

		getSize () {
			return this.colors.size();
		}

		sortConditionalPaletteByValue(options = {}){
			this.colors.models = this.colors.sortBy('value', options);
		}

		addColor (color, options) {
			this.colors.add(new ConditionalStyle(color), options);
			// sort the palette by value
			this.sortConditionalPaletteByValue(options);
		}

		/**
		 * @param values an array of values that is assumed to be in the same order as what currently exists
		 */
		updateStyleValues (values = [], options) {
			if(values.length === this.colors.size()) {
				for(var i=0; i < this.getSize(); i++) {
					this.colors.getColor(i).setValue(values[i], options);
				}
			}
		}

		addColors (colors = [], options) {
			colors.forEach(color => {
				this.colors.add(new ConditionalStyle(color), options);
			});

			// sort the palette by value
			if (this.colors.size() > 0) {
				this.sortConditionalPaletteByValue(options);
			}
		}

		getColor (index) {
			return this.colors.getColor(index);
		}

		getColorByValue (value) {
			let match = null;
			const valueToValidate = parseFloat(value);
			if (!isNaN(valueToValidate)) {
				const colors = this.colors.getColors();
				let nextColor = null;
				for (let i = 0; i < colors.length;) {
					const color = colors[i++];
					nextColor = i < colors.length ? colors[i] : null;
					// Checking the second last to last range is an inclusive test (<= and >=) where as
					// checking all other ranges is left inclusive only (<= and >)
					if (!nextColor || (color.getValue() <= value && nextColor.getValue() > value) ||
						(i === colors.length - 1 && (color.getValue() <= value && nextColor.getValue() >= value))
					) {
						match = color;
						break;
					}
				}
			}
			return match;
		}

		updateColors (colors, options) {
			if (colors) {
				this.set({ colors: colors }, options);
			}
		}

		removeStyle (index, options) {
			this.removeStyles(index, 1, options);
		}

		/**
		 * Remove x number of colors and triggers one update event
		 */
		removeStyles  (index, count, options) {
			for (let i = 0; i < count; i++) {
				var model = this.getColor(index);
				if (model) {
					this.colors.remove(model, options);
				}
			}

			if(index === this.getSize()) {
				var lastItem = this.getColor(index-1);
				lastItem.clearStyle();
			}
		}

		clear (options) {
			if (this.colors) {
				this.colors.reset([], options);
			}
		}

		static createUndoRedoTransactionOptionsId (action) {
			return {
				payloadData: {
					undoRedoTransactionId: UniqueId.get('conditional_palette_' + action + '_')
				}
			};
		}
	};
});
